import QuillOutput from 'components/textbox/quilloutput'
import PropTypes from 'prop-types'
import QuestionHeader from './questionHeader'
import { CopyBlock, dracula } from 'react-code-blocks'

// elm.HTML used to be elm.Prompt, so we need backwards compatible code
export default function RenderTextBlock(props) {
  const { elmIndex, elm } = props
  if (elm.Prompt === elm.HTML) elm.Prompt = ''
  let code = ''
  if (elm.FormatAsCode) {
    const a = document.createElement('div')
    a.innerHTML = elm.HTML
    code = a.textContent
  }
  return <div key={elmIndex}>
    <QuestionHeader helpTooltip={elm.ShowHelpTooltip ? elm.HelpTooltip : ''} prompt={elm.HTML ? elm.Prompt : ''} allowBlanks={true} />
    {elm.FormatAsCode ?
      <CopyBlock text={code} language={'text'} wrapLines theme={dracula} /> :
      <QuillOutput key={elmIndex} html={elm.HTML || elm.Prompt} style={{ paddingLeft: '0px' }} center={elm.CenterText} />}
  </div>
}

RenderTextBlock.propTypes = {
  elmIndex: PropTypes.number.isRequired,
  elm: PropTypes.object.isRequired,
}